import script from "./TileProjectDashboardTasks.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileProjectDashboardTasks.vue?vue&type=script&setup=true&lang=ts"

import "./TileProjectDashboardTasks.vue?vue&type=style&index=0&id=232b4110&lang=css"

const __exports__ = script;

export default __exports__